import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../../../../../../../../../lib/designSystem/Button';
import dayjs from 'dayjs';
import {
  getShortString,
  showAlert,
} from '../../../../../../../../../../../../lib/functions/utils';
import { completeMultipleCollectionManagement } from '../../../../../../../../../../../../lib/api/collections';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../../../../lib/designSystem/CircularProgress';

const MultiComplete = (props: any) => {
  const {
    open,
    setOpen,
    managementsToComplete,
    byStakeholder,
    handleOpenCreateNewManagementFromCompletion,
    handleOpenCreateNewMultiManagementFromCompletion,
    reloadPage,
  } = props;
  const dispatch = useDispatch();
  const [managementsToCompleteFormatted, setManagementsToCompleteFormatted] =
    useState<any[]>([]);
  const [dataForRequest, setDataForRequest] = useState<any>({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [createNewManagement, setCreateNewManagement] = useState(false);
  const [createNewMultiManagement, setCreateNewMultiManagement] =
    useState(false);

  const documentId = managementsToComplete[0].documentId;
  const documentIds = managementsToComplete.map((management: any) => {
    return management.documentId;
  });

  const handleComplete = () => {
    const payload = {
      managements: managementsToCompleteFormatted.map((management: any) => {
        return {
          id: management.id,
          description: management.description,
          possiblePaymentDate:
            management.possiblePaymentDate === 'Invalid Date'
              ? null
              : management.possiblePaymentDate,
        };
      }),
    };
    setDataForRequest(payload);
    setOpenConfirmDialog(true);
  };

  const handleCompleteAndCreateNew = () => {
    setCreateNewManagement(true);
    handleComplete();
  };

  const handleCompleteAndCreateNewMultiManagement = () => {
    setCreateNewMultiManagement(true);
    handleComplete();
  };

  const handleConfirmComplete = async () => {
    setLoading(true);
    try {
      await completeMultipleCollectionManagement(dispatch, dataForRequest);
      showAlert(dispatch, 'success', 'Gestiones completadas correctamente');
      if (createNewManagement) {
        handleOpenCreateNewManagementFromCompletion(documentId);
      } else if (createNewMultiManagement) {
        handleOpenCreateNewMultiManagementFromCompletion(documentIds);
      } else {
        reloadPage();
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al completar las gestiones');
    }
    setLoading(false);
  };

  const formatManagementsToComplete = () => {
    const formattedManagements = managementsToComplete.map(
      (management: any) => {
        return {
          id: management.id,
          folio: management.folio,
          stakeholderName: management.stakeholderName,
          businessName: management.businessName,
          description: management.description,
          possiblePaymentDate: dayjs(management.possiblePaymentDate)
            .utc()
            .format('YYYY-MM-DD'),
        };
      },
    );
    setManagementsToCompleteFormatted(formattedManagements);
  };

  useEffect(() => {
    formatManagementsToComplete();
  }, [managementsToComplete]);

  return (
    <div>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xl">
        <DialogTitle>Completar gestiones</DialogTitle>
        <DialogContent>
          <Typography marginBottom={2} paddingRight={30}>
            Si quieres puedes editar la descripción de las gestiones para que
            queden completadas con la nueva información.
          </Typography>
          {managementsToCompleteFormatted.map((management: any) => (
            <Grid container key={management.id} spacing={2} marginBottom={2}>
              <Grid item xs={5.5}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '64px',
                  }}
                >
                  <Typography>
                    Folio #{management.folio} |{' '}
                    {getShortString(
                      byStakeholder
                        ? management.businessName
                        : management.stakeholderName,
                      20,
                    )}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '64px',
                  }}
                >
                  <TextField
                    fullWidth
                    multiline
                    value={management.description}
                    onChange={(e) => {
                      const newManagements = managementsToCompleteFormatted.map(
                        (m: any) => {
                          if (m.id === management.id) {
                            return { ...m, description: e.target.value };
                          }
                          return m;
                        },
                      );
                      setManagementsToCompleteFormatted(newManagements);
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={2.5}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '64px',
                  }}
                >
                  <TextField
                    id="outlined-basic-two"
                    label="Posible fecha de pago"
                    variant="outlined"
                    type="date"
                    value={management.possiblePaymentDate}
                    fullWidth
                    onChange={(e) => {
                      const newManagements = managementsToCompleteFormatted.map(
                        (m: any) => {
                          if (m.id === management.id) {
                            return {
                              ...m,
                              possiblePaymentDate: e.target.value,
                            };
                          }
                          return m;
                        },
                      );
                      setManagementsToCompleteFormatted(newManagements);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          ))}
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Cancelar
          </CustomButton>
          <CustomButton color="success" onClick={() => handleComplete()}>
            Completar
          </CustomButton>
          {managementsToCompleteFormatted.length === 1 && (
            <CustomButton
              color="success"
              onClick={() => handleCompleteAndCreateNew()}
            >
              Completar y crear nueva gestión
            </CustomButton>
          )}
          {managementsToCompleteFormatted.length > 1 && (
            <CustomButton
              color="success"
              onClick={() => handleCompleteAndCreateNewMultiManagement()}
            >
              Completar y crear nueva gestión multiple
            </CustomButton>
          )}
        </DialogActions>
      </Dialog>
      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
        >
          <DialogTitle>Confirmar</DialogTitle>
          <DialogContent>
            {loading ? (
              <div style={{ minHeight: '100px' }}>
                <CenteredCircularProgress type="dialog" />
              </div>
            ) : (
              <Typography>
                ¿Estás seguro de querer completar las gestiones?
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <CustomButton
              color="secondary"
              onClick={() => setOpenConfirmDialog(false)}
            >
              Cancelar
            </CustomButton>
            <CustomButton
              color="success"
              onClick={() => handleConfirmComplete()}
            >
              Confirmar
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default MultiComplete;
